/*
 * This file is part of glowingblue/newvigation.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat, Gianni Guida.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { override, extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import IndexPage from 'flarum/forum/components/IndexPage';
import NavElements from './components/NavElements';
import ItemList from 'flarum/common/utils/ItemList';
import * as user_directory from '@fof-user-directory';

export default function () {
	override(HeaderPrimary.prototype, 'view', function () {
		return <NavElements origItems={this.items()} />;
	});

	extend(IndexPage.prototype, 'navItems', function (origItems) {
		// Make a new ItemList with only items that have a priority greater than -10 (-12 is the priority of the separator for tags)
		const removedNavItems = new ItemList();

		origItems.toArray().forEach((item) => {
			const priority = origItems.getPriority(item.itemName);
			if (priority >= -10) {
				// Increase the priority so that those items will be displayed on top of other in the NavElements component
				removedNavItems.add(item.itemName, item, priority + 50);

				// Remove this items (and the separator) from the original list
				origItems.remove(item.itemName);
			}
		});

		origItems.remove('separator');

		// Save these removed items, we will use these in the NavElements component
		this._removedNavItems = removedNavItems;
	});

	IndexPage.prototype.removedNavItems = function () {
		this.navItems();

		// Calling the above method saves the wrong tag as `currentActiveTag`.
		// So we need to delete it so that it will be set normally once the `navItems`
		// method is called naturally during the rendering of `IndexPage`
		delete this.currentActiveTag;

		return this._removedNavItems;
	};

	if (app.initializers.has('fof-user-directory')) {
		extend(user_directory.UserDirectoryPage.prototype, 'navItems', function (items) {
			items.remove('fof-user-directory');
		});
	}
}
